if (typeof boostPFSThemeConfig !== 'undefined') {
    // Override Settings
    var boostPFSFilterConfig = {
        general: {
            limit: boostPFSConfig.custom.products_per_page,
            loadProductFirst: true,
            numberFilterTree: 2,
            selectOptionContainer: '.grid__item .card-wrapper',
            stickyFixTopPos: true
        },
        selector: {
            otpTopCartCount: '.cart-count-bubble'
        },
        custom: {
            show_price: true
        }
    };
}

(function () {
    var today = new Date();
  
    var onSale = false,
        soldOut = false,
        priceVaries = false,
        images = [],
        boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];
    
    
    BoostPFS.inject(this);
    /* For Filter Setting Layout */
    /* Start boost 150398 */
    if (boostPFSConfig.general.collection_handle == 'new-products') {
        boostPFSFilterConfig.general.limit = 16;
        jQ('.product-count__text').text("352 products");
    }
    /* End boost 150398 */
    Selector.stickyElementDesktop = jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';
    /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
    function prepareShopifyData(data) {
        // Displaying price base on the policy of Shopify, have to multiple by 100
        soldOut = !data.available; // Check a product is out of stock
        onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
        priceVaries = data.price_min != data.price_max; // Check a product has many prices
        // Convert images to array
        images = data.images_info;
        // Get First Variant (selected_or_first_available_variant)
        firstVariant = data['variants'][0];
        if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
            var paramVariant = data.variants.filter(function(e) {
                return e.id == Utils.getParam('variant');
            });
            if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
        } else {
            for (var i = 0; i < data['variants'].length; i++) {
                if (data['variants'][i].available) {
                    firstVariant = data['variants'][i];
                    break;
                }
            }
        }
        return data;
    }
    
    /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
    /************************** BUILD PRODUCT LIST **************************/
    // Build Product Grid Item
    ProductGridItem.prototype.compileTemplate = function(data) {
        if (!data) data = this.data;
        // Customize API data to get the Shopify data
        data = prepareShopifyData(data);
    
        // Get Template
        var itemHtml = boostPFSTemplate.productGridItemHtml;
    
        // Add Custom class
        var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
        var saleClass = onSale ? boostPFSTemplate.saleClass : '';
        var ratioImage = getRatioImage(data);
        var imageAspectRatio = ratioImage / getAspectRatio(data.images_info[0]) * 100;
    
        itemHtml = itemHtml.replace(/{{imageAspectRatio}}/g, imageAspectRatio);
    
        itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
    
    
        itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
    
        // Add Card product class
        itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass(data));
        // Add Card inner product class
        itemHtml = itemHtml.replace(/{{cardInnerProductClass}}/g, buildCardInnerProductClass(data));
        // Add Card badge position
        itemHtml = itemHtml.replace(/{{cardBadgePosition}}/g, boostPFSThemeConfig.custom.badge_position);
        // Add check card heading five
        itemHtml = itemHtml.replace(/{{cardIsHeadingFive}}/g, buildCardIsHeadingFive(data));
        // Add sold out Label
        itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
        // Add sale Label
        itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
        // Add Images
        itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
        // Add Price
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
        // Add Price with VAT
        itemHtml = itemHtml.replace(/{{itemPriceWithVAT}}/g, buildPriceVAT(data));
    
    
        // Add Review
        if (typeof Integration === 'undefined' ||
            (typeof Integration != 'undefined' &&
                typeof Integration.hascompileTemplate == 'function' &&
                !Integration.hascompileTemplate('reviews'))) {
            itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
        }
    
        // Add Description
        itemHtml = itemHtml.replace(/{{itemDescription}}/g, boostPFSThemeConfig.custom.description || '');
    
        // Add Vendor
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
    
        var handle = data.handle;
    
        handle = handle.replace(/ /g, "");
    
        //check if first id is for pers object
        var variantIdCustom = data.variants[0].id;
        if (data.variants[0].title.includes("PERS")) {
            variantIdCustom = data.variants[1]?.id || '';
        }
    
        var sku = data.skus.length > 0 ? data.skus[0] : data.variants[0]['sku'];
        // Add main attribute (Always put at the end of this function)
        itemHtml = itemHtml.replace(/{{item}}/g, data);
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemBadges}}/g, buildBadges(data));
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, handle);
        itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
        itemHtml = itemHtml.replace(/{{itemFirstVariantId}}/g, data.variants[0].id); // Added first variant id reference - NS
        itemHtml = itemHtml.replace(/{{itemSku}}/g, sku !== '' ? sku.replace("-PERS", "") : ''); // Added SKU reference - NS
        itemHtml = itemHtml.replace(/{{itemInventory}}/g, buildInventory(data));
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
        itemHtml = itemHtml.replace(/{{itemVarId}}/g, variantIdCustom); // NS - Custom properties to grab variant id
        itemHtml = itemHtml.replace(/{{itemVarId}}/g, data.variants[0].id); // NS - Custom properties to grab variant id
        itemHtml = itemHtml.replace(/{{itemVarTitle}}/g, data.variants[0].title); // NS - Custom properties to grab variant title
    
        itemHtml = itemHtml.replace(/{{itemVariants}}/g, buildVariants(data)); // NS - Custom properties to grab variant title
        itemHtml = itemHtml.replace(/{{itemVariantsDrop}}/g, buildVariantsdropdown(data)); // NS - Custom properties to grab variant title
    
        itemHtml = itemHtml.replace(/{{itemATC}}/g, buildATC(data));
    
        return itemHtml;
    };
    
    //RCA_AA NEW UPDATED VERSION OF THE BUILD INVNETORY FUNCTION, PREVIOUSE FUNCTION ON LEGACY THEMES 
    //DID NOT DO A CHECK TO SEE WHICH VARAINT IS AVAILABLE, THIS FUNCTION DOES THAT CHECK AND THEN RETURNS THE INVENTORY
    //POLICY OF THE FIRST AVAILABLE VARIANT GIVING A MORE ACCURATE INVENTORY COUNT FOR THE PRODUCTS. 
    
    function buildInventory(data) {
        var html = '';
    
        var firstAvailableVariant;
    
        for (var i = 0; i < data.variants.length; i++) {
            if (data.variants[i].available) {
                firstAvailableVariant = data.variants[i];
                break;
            }
        }
        if (firstAvailableVariant) {
            if (firstAvailableVariant.inventory_policy == 'deny') {
                var variant = firstAvailableVariant.inventory_quantity;
                if (variant < 10) {
                    if (variant <= 0) {
                        html += '<span class="card__inventory">In stock</span>';
                    } else {
                        html += '<span class="card__inventory">Stock ' + variant + '</span>';
                    }
                } else if (variant >= 10 && variant < 20) {
                    html += `<span class="card__inventory">Stock ${variant}</span>`;
                } else if (variant >= 20) {
                    html += '<span class="card__inventory">Stock 20+</span>';
                }
            } else {
                if (firstAvailableVariant.inventory_policy == 'continue') {
                    var variant = firstAvailableVariant.inventory_quantity;
                    if (variant < 10) {
                        if (variant <= 0) {
                            // ADD LOGIC IF INVENTORY IS CONTINUE AND QUANTITY IS NEGATIVE  CURRENTLY 
                            // LEFT BLANK AS SITE IS NOT GOT ANY CONTINUE SELLING WHEN OUT OF STOCK 
                            // PRODUCTS OR NEVATIVE INVENTORY COUNT.
                        } else {
                            html += '<span class="card__inventory">Stock ' + variant + '</span>';
                        }
                    } else if (variant >= 10 && variant < 20) {
                        html += `<span class="card__inventory">Stock ${variant}+</span>`;
                    } else if (variant > 20) {
                        html += '<span class="card__inventory">Stock 20+</span>';
                    }
                }
            }
        } else {
            html += ' <span style="color: red;">Out of Stock</span>';
        }
    
        return html;
    }
    
    function buildBadges(data) {
        var html = '';
        var created = new Date(data.created_at);
        var sale = false;
        var days = typeof moment !== 'undefined' ? moment().diff(created, "days") : '';
        if (data.available == false) {
            html += '<span class="badge sold_out">SOLD OUT</span>';
        }
    
        if (data.price_min < data.compare_at_price_min) {
            html += '<span class="badge sale">SALE</span>';
            var sale = true;
        }
        /*if(sale == true){
        }
        else{
        if (days < 20 && (data.available == true || data.variants[0].inventory_quantity > 0)) {
          html += '<span class="badge new xxx">NEW</span>';
        }
        }*/
    
        data.tags.forEach(function(item) {
            if (item == 'personalise') {
                html += '<span class="badge personalise">PERSONALISE ME</span>';
            } else if (item == 'New' && (data.available == true || data.variants[0].inventory_quantity > 0)) {
                html += '<span class="badge new">NEW</span>';
            }
        });
    
        return html;
    }
    
    function buildATC(data) {
        // Add to Bag btn
        var html = '';
    
        var variant = data.variants;
    
        if (variant.length > 1) {
            for (var i = 0; i < variant.length; i++) {
                if (variant[i].inventory_quantity > 0) {
                    if (window.innerWidth < 767) {
                        html += '<button type="button" name="add" class="quick-add__submit quickadd_boost button button--full-width button--primary newaddbtn">ADD TO CART</button>';
                    } else {
                        html += '<button type="button" name="add" disabled class="quick-add__submit quickadd_boost button button--full-width button--primary">Select an option</button>';
                    }
                } else if (variant[i].inventory_quantity <= 0 && (variant[i].inventory_policy === 'deny' || variant[i].inventory_policy === 'continue')) {
                    if (window.innerWidth < 767) {
                        html += '<button type="button" name="add" disabled class="quick-add__submit quickadd_boost button button--full-width button--primary newaddbtn">ADD TO CART</button>';
                    } else {
                        html += '<button type="button" name="add" disabled class="quick-add__submit quickadd_boost button button--full-width button--primary">Select an option</button>';
                    }
                } else if ((variant[i].inventory_quantity <= 0 && (variant[i].available === false || variant[i].inventory_policy != 'deny' || variant[i].inventory_policy != 'continue'))) {
                    html += '<button type="submit" name="add" disabled class="quick-add__submit button button--full-width button--primary">Sold Out</button>';
                } else {
                    html += '<button type="submit" name="add" disabled class="quick-add__submit button button--full-width button--primary">Sold Out</button>';
                }
                return html;
            }
        } else {
            for (var i = 0; i < variant.length; i++) {
                if (variant[i].inventory_quantity > 0) {
                    html += '<button type="button" name="add" class="quick-add__submit quickadd_boost button button--full-width button--primary newaddbtn">Add to cart</button>';
                } else if (variant[i].inventory_quantity <= 0 && (variant[i].inventory_policy === 'deny' || variant[i].inventory_policy === 'continue')) {
                    html += '<button type="button" name="add" disabled class="quick-add__submit quickadd_boost button button--full-width button--primary newaddbtn">Add to cart</button>';
                } else if ((variant[i].inventory_quantity <= 0 && (variant[i].available === false || variant[i].inventory_policy != 'deny' || variant[i].inventory_policy != 'continue'))) {
                    html += '<button type="submit" name="add" disabled class="quick-add__submit button button--full-width button--primary">Sold Out</button>';
                } else {
                    html += '<button type="submit" name="add" disabled class="quick-add__submit button button--full-width button--primary">Sold Out</button>';
                }
                return html;
            }
        }
    }
    
    
    function buildVariantsdropdown(data) {
        var html = '';
        var option = data.options_with_values
        var variants = data.variants;
        var invclass = '';
        var variantlist = "";
        var item, i;
        for (let i = 0; i < option.length; i++) {
            /*if(option[i].label.includes('Default Title') || option[i].label.includes('Title')){
            }else{
              html += `<p>Choose ${option[i].label}</p>`;
            }*/
            if (option[i].label.includes('Clothing Size') || option[i].label.includes('Size')) {
                variantlist = ["2-3 Years", "3-4 Years", "5-6 Years", "7-8 Years", "8-9 Years", "10-11 Years", "11-12 Years", "12-13 Years", "Youth Small", "Youth Medium", "Youth Large", "Youth XL", "Extra Small", "Small", "Medium", "Large", "XL", "2XL", "3XL", "4XL", "5XL", "6XL", "7XL+", "No Size"];
            }
            if (option[i].label.includes('Colour')) {
                variantlist = ["Aqua", "Aqua Blue", "Aqua Blue Green", "Aqua Blue Red", "Baby Blue", "Baby Pink", "Berry", "Black", "Black Blue", "Black Gold", "Black Green", "Black Grey", "Black Orange", "Black Pink", "Black Purple", "Black Red", "Black Silver", "Black White", "Black Yellow", "Blue", "Blue Black", "Blue Hawaii", "Blue Maroon", "Blue Silver", "Blue White", "Blue Yellow", "Blueberry", "Brass", "Bronze", "Brown", "Burgundy", "Claret Blue", "Clear", "Clear Black", "Clear Blue", "Clear Green", "Clear Orange", "Clear Pink", "Clear Purple", "Clear Red", "Clear White", "Clear Yellow", "Copper", "Cream", "Cyan", "Dark Black", "Dark Blue", "Dark Green", "Dark Pink", "Deep Purple", "Deep Red", "Emerald", "Fluro Green", "Fluro Orange", "Fluro Pink", "Fluro Red", "Fluro Yellow", "Gold", "Gold Black", "Green", "Green - Apple", "Green Black", "Green White", "Grey", "Grey Blue", "Grey Clear", "Grey Green", "Grey Purple", "Grey Red", "Gun Metal", "Hot Pink", "Ideal Green", "Jade", "Khaki", "Lemon", "Light Blue", "Light Green", "Lime", "Lime Green", "Magenta", "Magenta Sparkles", "Mango", "Metal Blue", "Metal Red", "Miracle Green", "Mondrian Red", "Multi", "Multicolour", "Mustard", "Natural", "Natural White", "Navy Blue", "Neon Blue", "Neon Green", "Neon Orange", "Neon Pink", "Neon Yellow", "Orange", "Orange Black", "Pacific Green", "Pink", "Pink - Grapefruit", "Pink Black", "Pink Clear", "Pink Gold", "Plain Black", "Plain Blue", "Plain Clear", "Plain Green", "Plain Orange", "Plain Pink", "Plain Red", "Plain White", "Plain Yellow", "Purple", "Purple - Grape", "Purple Black", "Purple Sparkles", "Rainbow", "Raspberry", "Red", "Red - Strawberry", "Red Black", "Red Eye", "Red Silver", "Red White", "Red White Blue", "Red Yellow", "Rosewood", "Rosso", "Royal Blue", "Ruby Red", "Rustic", "Shadow Blue", "Silver", "Silver Black", "Sky Blue", "Sky White", "Smokey", "Snow", "Sparkles", "Strawberry", "Suika", "Sunrise", "Sunset Gold", "Teal", "Transparent", "Turquoise", "White", "White Black", "White Blue", "White Green", "White Orange", "White Pink", "White Red", "White Yellow", "Yellow", "Yellow - Pineapple", "Yellow Green", "Yellow Red"];
            }
            if (option[i].label.includes('Design')) {
                variantlist = ["EU Edition", "UK Edition", "Union Jack"];
            }
            if (option[i].label.includes('Point Length')) {
                variantlist = ["22mm", "25mm", "26mm", "28mm", "30mm", "31mm", "32mm", "33mm", "34mm", "35mm", "36mm", "37mm", "38mm", "39mm", "40mm", "41mm", "42mm", "44mm", "45mm", "48mm", "50mm", "Short", "Medium", "Long", "No Length"];
            }
            if (option[i].label.includes('Shaft Size')) {
                variantlist = ["23mm - Short", "26mm - Short Plus", "29mm - Tweenie", "32mm - Tweenie Plus", "35mm - Medium", "38mm - Medium Plus", "Micro", "Ultra Short", "Extra Short", "Short", "Short Plus", "Tweenie", "Tweenie Plus", "Medium", "Medium Plus", "Long", "Spare Tops", "No size"];
            }
            if (option[i].label.includes('Shape')) {
                variantlist = ["Shape D-1", "Shape D-2", "Shape D-3", "Shape D-4", "Shape D-5", "Shape D-6", "Shape S-1", "Shape S-2", "Shape S-3", "Shape S-4", "Shape S-5", "Shape S-6", "Shape V-1", "Shape V-2", "Shape V-3", "Shape V-4", "Shape V-5", "Shape V-6", "Style A", "Style B", "Style C", "Style D", "Style E", "Style F"];
            }
            if (option[i].label.includes('Specialist Shaft Size')) {
                variantlist = ["Cosmo Size 1 - 13mm", "Cosmo Size 2 - 18mm", "Cosmo Size 3 - 24mm", "Cosmo Size 4 - 28mm", "Cosmo Size 5 - 31mm", "Cosmo Size 6 - 35mm", "Cosmo Size 7 - 38mm", "Cosmo Size 8 - 42mm", "Cuesoul 25mm", "Cuesoul 32mm", "Cuesoul 34mm", "Cuesoul 37mm", "Cuesoul 40mm", "Cuesoul 43.5mm", "Cuesoul 47mm", "Cuesoul 53mm", "L Style 130 27mm Extra Short", "L Style 130 30mm Extra Short", "L Style 190 33mm Short", "L Style 190 35mm Short", "L Style 225 36.5mm Short", "L Style 260 40mm Tweenie", "L Style 260 42mm Tweenie", "L Style 295 43.5mm Medium", "L Style 300 44mm Tweenie", "L Style 300 Slim 44mm Tweenie", "L Style 330 47mm Medium", "L Style 330 49mm Medium", "L Style 370 51mm Medium", "L Style 370 Slim 51mm Medium", "L Style 440 58mm Long", "L Style 440 Slim 58mm Long", "No size"];
            }
            if (option[i].label.includes('Style')) {
                variantlist = ["Animals", "Aurora", "AUS Plug", "Black", "Bottle Logo", "Cartouche Logo", "Circus", "Comet", "Dartboard", "Dragon", "Earth", "England", "EU Plug", "Face 1", "Face 2", "Face 3", "Face 4", "Face 5", "Face 6", "Face 7", "Face 8", "Firestorm", "Galaxy", "Hydrostorm", "Icestorm", "Ireland", "JD Logo", "Mars,Max Air 1", "Max Air 2", "Max Air 3", "Max Air 4", "Max Air 5", "Max Air 6", "Meteor", "Moon", "Nebula", "Off The Edge", "Old No7 Logo", "Panther", "Play Dead", "Pudding", "Pulsar", "Rudolf", "Santa", "Scotland", "Shooting Star", "Snowman", "Thunderstorm", "Tiger", "Tree in a Bed", "UK Plug", "USA Plug", "Wales", "Wolf"];
            }
            if (option[i].label.includes('Weight')) {
                variantlist = ["10g", "12g", "13g", "14g", "15g", "16g", "17g", "18g", "19g", "20g", "21g", "22g", "23g", "24g", "25g", "26g", "27g", "28g", "29g", "30g", "31g", "32g", "33g", "34g", "35g", "36g", "38g", "40g", "42g", "44g", "45g", "48g"];
            }
        }
        for (i = 0; i < variantlist.length; ++i) {
            item = variantlist[i];
    
            for (let i = 0; i < variants.length; i++) {
                if (variants[i].inventory_quantity <= 0 && variants[i].inventory_policy == 'deny') {
                    var invclass = 'soldoutvar';
                } else {
                    var invclass = '';
                }
                if (variants[i].title == item) {
                    if (variants[i].title.includes('-Pers') || variants[i].title.includes('PERS')) {} else {
                        html += `<option  ${i == 0 ? "selecteds" : ""} ${variants[i].available ? "selecteds" : "disabled"} value="${variants[i].id}">${variants[i].title}</option>`;
                    }
                }
            }
        }
        return html;
    }
    
    function buildVariants(data) {
        // Add to Bag btn
        var html = '';
        var option = data.options_with_values
        var variants = data.variants;
        var invclass = '';
        var variantlist = "";
        var sizeFlag = false;
        var item, i;
        for (let i = 0; i < option.length; i++) {
            if (option[i].label.includes('Default Title') || option[i].label.includes('Title') || option[i].label.includes('PersOption')) {} else {
                html += `<p>Choose ${option[i].label}</p>`;
            }
            if (option[i].label.includes('Clothing Size') || option[i].label.includes('Size')) {
                variantlist = ["2-3 Years", "3-4 Years", "5-6 Years", "7-8 Years", "8-9 Years", "10-11 Years", "11-12 Years", "12-13 Years", "Youth Small", "Youth Medium", "Youth Large", "Youth XL", "Extra Small", "Small", "Medium", "Large", "XL", "2XL", "3XL", "4XL", "5XL", "6XL", "7XL+", "No Size"];
                sizeFlag = true;
            }
            if (option[i].label.includes('Colour')) {
                variantlist = ["Aqua", "Aqua Blue", "Aqua Blue Green", "Aqua Blue Red", "Baby Blue", "Baby Pink", "Berry", "Black", "Black Blue", "Black Gold", "Black Green", "Black Grey", "Black Orange", "Black Pink", "Black Purple", "Black Red", "Black Silver", "Black White", "Black Yellow", "Blue", "Blue Black", "Blue Hawaii", "Blue Maroon", "Blue Silver", "Blue White", "Blue Yellow", "Blueberry", "Brass", "Bronze", "Brown", "Burgundy", "Claret Blue", "Clear", "Clear Black", "Clear Blue", "Clear Green", "Clear Orange", "Clear Pink", "Clear Purple", "Clear Red", "Clear White", "Clear Yellow", "Copper", "Cream", "Cyan", "Dark Black", "Dark Blue", "Dark Green", "Dark Pink", "Deep Purple", "Deep Red", "Emerald", "Fluro Green", "Fluro Orange", "Fluro Pink", "Fluro Red", "Fluro Yellow", "Gold", "Gold Black", "Green", "Green - Apple", "Green Black", "Green White", "Grey", "Grey Blue", "Grey Clear", "Grey Green", "Grey Purple", "Grey Red", "Gun Metal", "Hot Pink", "Ideal Green", "Jade", "Khaki", "Lemon", "Light Blue", "Light Green", "Lime", "Lime Green", "Magenta", "Magenta Sparkles", "Mango", "Metal Blue", "Metal Red", "Miracle Green", "Mondrian Red", "Multi", "Multicolour", "Mustard", "Natural", "Natural White", "Navy Blue", "Neon Blue", "Neon Green", "Neon Orange", "Neon Pink", "Neon Yellow", "Orange", "Orange Black", "Pacific Green", "Pink", "Pink - Grapefruit", "Pink Black", "Pink Clear", "Pink Gold", "Plain Black", "Plain Blue", "Plain Clear", "Plain Green", "Plain Orange", "Plain Pink", "Plain Red", "Plain White", "Plain Yellow", "Purple", "Purple - Grape", "Purple Black", "Purple Sparkles", "Rainbow", "Raspberry", "Red", "Red - Strawberry", "Red Black", "Red Eye", "Red Silver", "Red White", "Red White Blue", "Red Yellow", "Rosewood", "Rosso", "Royal Blue", "Ruby Red", "Rustic", "Shadow Blue", "Silver", "Silver Black", "Sky Blue", "Sky White", "Smokey", "Snow", "Sparkles", "Strawberry", "Suika", "Sunrise", "Sunset Gold", "Teal", "Transparent", "Turquoise", "White", "White Black", "White Blue", "White Green", "White Orange", "White Pink", "White Red", "White Yellow", "Yellow", "Yellow - Pineapple", "Yellow Green", "Yellow Red"];
            }
            if (option[i].label.includes('Design')) {
                variantlist = ["EU Edition", "UK Edition", "Union Jack"];
            }
            if (option[i].label.includes('Point Length')) {
                variantlist = ["22mm", "25mm", "26mm", "28mm", "30mm", "31mm", "32mm", "33mm", "34mm", "35mm", "36mm", "37mm", "38mm", "39mm", "40mm", "41mm", "42mm", "44mm", "45mm", "48mm", "50mm", "Short", "Medium", "Long", "No Length"];
            }
            if (option[i].label.includes('Shaft Size')) {
                variantlist = ["23mm - Short", "26mm - Short Plus", "29mm - Tweenie", "32mm - Tweenie Plus", "35mm - Medium", "38mm - Medium Plus", "Micro", "Ultra Short", "Extra Short", "Short", "Short Plus", "Tweenie", "Tweenie Plus", "Medium", "Medium Plus", "Long", "Spare Tops", "No size"];
            }
            if (option[i].label.includes('Shape')) {
                variantlist = ["Shape D-1", "Shape D-2", "Shape D-3", "Shape D-4", "Shape D-5", "Shape D-6", "Shape S-1", "Shape S-2", "Shape S-3", "Shape S-4", "Shape S-5", "Shape S-6", "Shape V-1", "Shape V-2", "Shape V-3", "Shape V-4", "Shape V-5", "Shape V-6", "Style A", "Style B", "Style C", "Style D", "Style E", "Style F"];
            }
            if (option[i].label.includes('Specialist Shaft Size')) {
                variantlist = ["Cosmo Size 1 - 13mm", "Cosmo Size 2 - 18mm", "Cosmo Size 3 - 24mm", "Cosmo Size 4 - 28mm", "Cosmo Size 5 - 31mm", "Cosmo Size 6 - 35mm", "Cosmo Size 7 - 38mm", "Cosmo Size 8 - 42mm", "Cuesoul 25mm", "Cuesoul 32mm", "Cuesoul 34mm", "Cuesoul 37mm", "Cuesoul 40mm", "Cuesoul 43.5mm", "Cuesoul 47mm", "Cuesoul 53mm", "L Style 130 27mm Extra Short", "L Style 130 30mm Extra Short", "L Style 190 33mm Short", "L Style 190 35mm Short", "L Style 225 36.5mm Short", "L Style 260 40mm Tweenie", "L Style 260 42mm Tweenie", "L Style 295 43.5mm Medium", "L Style 300 44mm Tweenie", "L Style 300 Slim 44mm Tweenie", "L Style 330 47mm Medium", "L Style 330 49mm Medium", "L Style 370 51mm Medium", "L Style 370 Slim 51mm Medium", "L Style 440 58mm Long", "L Style 440 Slim 58mm Long", "No size"];
            }
            if (option[i].label.includes('Style')) {
                variantlist = ["Animals", "Aurora", "AUS Plug", "Black", "Bottle Logo", "Cartouche Logo", "Circus", "Comet", "Dartboard", "Dragon", "Earth", "England", "EU Plug", "Face 1", "Face 2", "Face 3", "Face 4", "Face 5", "Face 6", "Face 7", "Face 8", "Firestorm", "Galaxy", "Hydrostorm", "Icestorm", "Ireland", "JD Logo", "Mars,Max Air 1", "Max Air 2", "Max Air 3", "Max Air 4", "Max Air 5", "Max Air 6", "Meteor", "Moon", "Nebula", "Off The Edge", "Old No7 Logo", "Panther", "Play Dead", "Pudding", "Pulsar", "Rudolf", "Santa", "Scotland", "Shooting Star", "Snowman", "Thunderstorm", "Tiger", "Tree in a Bed", "UK Plug", "USA Plug", "Wales", "Wolf"];
            }
            if (option[i].label.includes('Weight')) {
                variantlist = ["10g", "12g", "13g", "14g", "15g", "16g", "17g", "18g", "19g", "20g", "21g", "22g", "23g", "24g", "25g", "26g", "27g", "28g", "29g", "30g", "31g", "32g", "33g", "34g", "35g", "36g", "38g", "40g", "42g", "44g", "45g", "48g"];
            }
        }
    
        for (i = 0; i < variantlist.length; ++i) {
            item = variantlist[i];
    
            for (let i = 0; i < variants.length; i++) {
                if (variants[i].inventory_quantity <= 0 && variants[i].inventory_policy == 'deny') {
                    var invclass = 'soldoutvar';
                } else {
                    var invclass = '';
                }
                if (variants[i].title == item) {
                    if (variants[i].title.includes('-Pers') || variants[i].title.includes('PERS')) {} else {
                        /*if(sizeFlag){
                          if(variants[i].title == "Small"){
                            variants[i].title = "S";
                          }
                           if(variants[i].title == "Medium"){
                             variants[i].title = "M";
                            
                          }
                           if(variants[i].title == "Large"){
                             variants[i].title = "L";
                            
                          }
                        }*/
                        html += `<button type="button" class="card-variants__variant ${invclass}" data-id="${variants[i].id}">${variants[i].title}</button>`;
    
                    }
                }
            }
        }
        return html;
    }
    
    /************************** END BUILD PRODUCT LIST **************************/
    /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
    function buildImages(data) {
        var html = '';
        if (images && Array.isArray(images) && images.length > 0) {
            html += '<div class="card__media">';
            var aspectRatio = '',
                rangeWidths = boostPFSRangeWidths;
    
            var dataSrcSet = '',
                imgAlt = data.title,
                flipImageSrcSet = '';
    
            var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
                boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
                boostPFSThemeConfig.custom.show_secondary_image == true;
    
            for (var i = 0; i < rangeWidths.length; i++) {
                dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
    
                if (activeSwapImage) {
                    flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
                }
    
                if (i < rangeWidths.length - 1) {
                    dataSrcSet += ', ';
    
                    if (activeSwapImage) {
                        flipImageSrcSet += ', ';
                    }
                }
            }
    
    
            aspectRatio = images[0]['width'] / images[0]['height'];
            html += '<a href="/products/' + data.handle + '" class="media media--transparent media--hover-effect"><img class="aaa motion-reduce Image--lazyLoad"' +
                'loading="lazy"' +
                'height="' + images[0].height + '" ' +
                'width="' + images[0].width + '" ' +
                'data-src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
    
                'alt="' + imgAlt + '" />';
    
            if (activeSwapImage) {
                html += '<img class="motion-reduce Image--lazyLoad"' +
                    'loading="lazy"' +
                    'srcset="' + flipImageSrcSet + '" ' +
                    'height="' + images[1].height + '" ' +
                    'width="' + images[1].width + '" ' +
                    'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
                    'data-src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
    
                    'alt="' + imgAlt + '" />';
            }
            html += '</div>';
            html += '</a>';
        } else {
            html += '<a href="/products/' + data.handle + '" class="media media--transparent media--hover-effect"><img class="aaa motion-reduce"' +
                'loading="lazy"' +
                'data-src="https://cdn.shopify.com/s/files/1/0612/5368/1334/files/white.jpg?v=1664877239" ' +
                'alt="' + imgAlt + '" /></a>';
    
        }
        return html;
    }
    
    function buildCardProductClass(data) {
        var html = '' + boostPFSThemeConfig.custom.card_style;
        if (!images) {
            html += ' card--text';
        } else {
            html += ' card--media';
        }
        if (boostPFSThemeConfig.custom.card_style == 'card') {
            html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
        }
        if (!images && boostPFSThemeConfig.custom.card_style == 'card') {
            html += ' ratio';
        }
        return html;
    }
    
    function buildCardInnerProductClass(data) {
        var html = '';
        if (boostPFSThemeConfig.custom.card_style == 'standard') {
            html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
        }
        if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
            html += ' ratio';
        }
        return html;
    }
    
    function buildCardIsHeadingFive(data) {
        var html = '';
        if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
            html = 'h5';
        }
        return html;
    }
    
    function buildVendor(data) {
        var html = '';
        if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
            boostPFSThemeConfig.custom.show_vendor === true) {
            html = boostPFSTemplate.vendorHtml;
        }
        return html;
    }
    
    // function buildPrice(data) {
    //   var html = '';
    //   var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
    //   var priceAmount = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min, 'money_with_currency') : Utils.formatMoney(data.price_min);
    //   var compareAtPrice = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') : Utils.formatMoney(data.compare_at_price_min);
    //   var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount) : priceAmount;
    //   var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
    //   html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}">
    //         <div class="price__container">
    //           <div class="price__regular">
    //             <span class="visually-hidden visually-hidden--inline">
    //               ${boostPFSConfig.label.regular_price}
    //             </span>
    //             <span class="price-item price-item--regular">
    //               ${moneyPrice}
    //             </span>
    //           </div>
    //           <div class="price__sale">
    //             <span class="visually-hidden visually-hidden--inline">
    //               ${boostPFSConfig.label.regular_price}
    //             </span>
    //             <span>
    //               <s class="price-item price-item--regular">
    //                 ${compareAtPrice}
    //               </s>
    //             </span>
    //             <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
    //             <span class="price-item price-item--sale price-item--last">
    //               ${moneyPrice}
    //             </span>
    //           </div>
    //           <small class="unit-price caption ${unitPriceClass}">
    //             <span class="visually-hidden">${boostPFSConfig.label.unit_price}</span>
    //             <span class="price-item price-item--last">
    //               <span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
    //               <span aria-hidden="true">/</span>
    //               <span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
    //             </span>
    //           </small>
    //         </div>
    //       </div>`
    //   return html;
    // }
    function buildPrice(data) {
        var html = '';
        // var priceVat = ''
        if (boostPFSThemeConfig.custom.hasOwnProperty('show_price') &&
            boostPFSThemeConfig.custom.show_price) {
            onSale = data.compare_at_price_min !== 0 && data.compare_at_price_min > data.price_min ? true : false;
            if (boostPFSConfig.customer.isLogged && boostPFSConfig.customer.tags[0] === "Trade") {
                html = '<div class="price">';
                html += '<div class="price__container">';
    
                if (onSale) {
                    // html += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.sale_price + '</span>';
                    if (priceVaries) {
                        html += '<span class="boost-pfs-filter-product-item-sale-price">' + boostPFSThemeConfig.label.from_price_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min)) + '</span>';
                    } else {
                        html += '<span class="boost-pfs-filter-product-item-sale-price">' + Utils.formatMoney(data.price_min) + '</span>';
                    }
                    html += '<s>' + Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') + '</s> ';
                } else {
                    html += '<div class="price__regular">';
                    html += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
                    if (priceVaries) {
                        // html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label.from_price_html) + ' ' + '</span>';
                        html += '<span class="boost-pfs-filter-product-item-regular-price price-item price-item--regular price-vat">' + boostPFSThemeConfig.label.from_price_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min)) + '' + '</span>';
                    } else {
                        html += '<span class="boost-pfs-filter-product-item-regular-price price-item price-item--regular price-vat">' + Utils.formatMoney(data.price_min) + '' + '</span>';
                    }
                    html += '</div>';
                }
    
                html += '</div>';
                html += '</div>';
            } else {
                if (onSale) {
                    html = '<div class="price price--on-sale">';
                } else {
                    html = '<div class="price">';
                }
                html += '<div class="price__container">';
                if (onSale) {
                    // html += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.sale_price + '</span>';
                    if (priceVaries) {
                        html += '<span class="boost-pfs-filter-product-item-sale-price" style="padding-right: 10px;"><strong>' + boostPFSThemeConfig.label.from_price_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min)) + '</strong></span>';
                    } else {
                        html += '<span class="boost-pfs-filter-product-item-sale-price" style="padding-right: 10px;"><strong>' + Utils.formatMoney(data.price_min) + '</strong></span>';
                    }
                    if (data.compare_at_price_min !== 0) {
                        html += '<s class="price-item--regular">' + Utils.formatMoney(data.compare_at_price_min) + '</s> ';
                    }
                } else {
                    html += '<div class="price__regular">';
                    html += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
                    if (priceVaries) {
                        // html += '<span class="boost-pfs-filter-product-item-price-from-text">' + (boostPFSThemeConfig.label.from_price_html) + ' ' + '</span>';
                        html += '<span class="boost-pfs-filter-product-item-regular-price price-item price-item--regular">' + boostPFSThemeConfig.label.from_price_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min)) + '' + '</span>';
                    } else {
                        html += '<span class="boost-pfs-filter-product-item-regular-price price-item price-item--regular">' + Utils.formatMoney(data.price_min) + '' + '</span>';
                    }
                    html += '</div>';
                }
                html += '</div>';
                html += '</div>';
            }
        }
        return html;
    }
    
    function buildPriceVAT(data) {
        var html = '';
        if (data.product_type != 'Gift Cards') {
            var priceWithVAT = data.price_min;
            var priceAmount = Utils.formatMoney(priceWithVAT);
            var comparePrice = data.compare_at_price_min;
            if (onSale) {
                html += '<s style="color: #a0a0a0">' + Utils.formatMoney(comparePrice) + '</s> ';
                html += `<strong>${priceAmount}</strong>`;
            } else {
                html += `<strong>${priceAmount}</strong>`;
            }
        } else {
            var priceWithVAT = data.price_min;
            var priceAmount = Utils.formatMoney(priceWithVAT);
            html += `<strong>${priceAmount}</strong>`;
        }
        return html;
    }
    
    function buildSoldOutLabel() {
        // Build Sold out label
        var soldOutLabel = '';
        if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
            soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
        }
        return soldOutLabel;
    }
    
    function buildSaleLabel() {
        // Build Sale label
        var saleLabel = '';
        if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
            saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
        }
        return saleLabel;
    }
    
    function buildReview(data) {
        var html = '';
        if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
            boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
            var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
            var rating_decimal = 0;
            var decimal = parseFloat(ratingObj.value.rating);
            if (decimal >= 0.3 && decimal <= 0.7) {
                rating_decimal = 0.5;
            } else if (decimal > 0.7) {
                rating_decimal = 1;
            }
            html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                          <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
                        </div>
                        <p class="rating-text caption">
                          <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
                        </p>
                        <p class="rating-count caption">
                          <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                          <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
                        </p>`;
        }
        return html;
    }
    
    function getAspectRatio(data) {
        var width = (data == null) ? '535' : data.width;
        var height = (data == null) ? '535' : data.height;
    
        return width / height;
    }
    
    function getRatioImage(data) {
        var ratio = 1;
        if (images && boostPFSThemeConfig.custom.media_size == 'portrait') {
            ratio = 0.8;
        } else if (images && boostPFSThemeConfig.custom.media_size == 'adapt') {
            ratio = getAspectRatio(data.images[0]);
        }
        if (ratio === 0 || ratio === null) {
            ratio = 1;
        }
        return ratio;
    }
    
    /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
    /************************** BUILD TOOLBAR **************************/
    // Build Pagination
    ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
        if (!totalProduct) totalProduct = this.totalProduct;
        // Get page info
        var currentPage = parseInt(Globals.queryParams.page);
        var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
        // If it has only one page, clear Pagination
        if (totalPage <= 1) {
            return '';
        }
    
        var paginationHtml = boostPFSTemplate.paginateHtml;
        // Build Previous
        var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
        // Build Next
        var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);
        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }
        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
        return paginationHtml;
    };
    
    // Build Sorting
    ProductSorting.prototype.compileTemplate = function() {
        var html = '';
        if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
            var sortingArr = Utils.getSortingList();
            if (sortingArr) {
                var paramSort = Globals.queryParams.sort || '';
                // Build content
                var sortingItemsHtml = '';
                for (var k in sortingArr) {
                    var isSelected = ''
                    if (paramSort == k) {
                        isSelected = 'selected="selected"'
                    }
                    sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
                }
                html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            }
        }
        return html;
    };
    
    ProductSorting.prototype.render = function() {
        jQ(Selector.topSorting).html(this.compileTemplate());
    
        if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
            jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
        }
    
        var labelSort = '';
        var paramSort = Globals.queryParams.sort || '';
        var sortingList = Utils.getSortingList();
        if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
            labelSort = sortingList[paramSort];
        } else {
            labelSort = Labels.sorting;
        }
    
        jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
    }
    
    // Build Sorting event
    ProductSorting.prototype.bindEvents = function() {
        jQ(Selector.topSorting + ' .facet-filters__sort').change(function(e) {
            e.preventDefault();
            FilterApi.setParam('sort', jQ(this).val());
            FilterApi.setParam('page', 1);
            FilterApi.applyFilter('sort');
        });
    };
    
    
    // Build Additional Elements
    Filter.prototype.afterRender = function(data, eventType) {
        if (!data) data = this.data;
        if (!eventType) eventType = this.eventType;
        if (boostPFSConfig.general.collection_handle == 'new-products') {
            $('.boost-pfs-filter-total-product').text("352 products");
        } else {
            jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
        }
    
        if (eventType == 'filter') {
            $('html, body').animate({
                scrollTop: $("#CollectionProductGrid").offset().top - 200
            }, 2000);
        }
        if (eventType !== 'init') {
            $('.card__heading').matchHeight();
            $('.card__sku').matchHeight();
        }
        $('.card__variants').each(function() {
            var option = $(this).find('button').text();
            if (option.includes('Default')) {
                $(this).css('opacity', '0');
            }
        });
      function extractTextFromURL(url) {
        // Finding the last '/' in the URL
        const lastSlashIndex = url.lastIndexOf('/');
      
        // Finding the position of '?' if it exists, otherwise the end of the string
        const questionMarkIndex = url.indexOf('?', lastSlashIndex);
        const endIndex = questionMarkIndex > -1 ? questionMarkIndex : url.length;
      
        // Extracting and returning the substring
        return url.substring(lastSlashIndex + 1, endIndex);
      }
     let currentCollection = extractTextFromURL(window.location.href).replaceAll("-"," ");
           console.log(currentCollection);

      function getCurrentTopLevelDomain() {
    try {
        let currentUrl = window.location.href;
        let urlObj = new URL(currentUrl);
        let hostname = urlObj.hostname;
        let parts = hostname.split('.');
        return parts[parts.length - 1]; // Returns the TLD
    } catch (e) {
        console.error("Error retrieving TLD", e);
        return null;
    }
}

let currentTld = getCurrentTopLevelDomain();
      console.log("this is the top level domainss");
console.log(currentTld); // Outputs the TLD of the current webpage


      var trackingProductsToSend = [];
      data.products.forEach((item,index) =>{
        if(currentTld == "eu" || currentTld == "de" || currentTld == "nl") {
           trackingProductsToSend.push({
          item_name:item.title,
          item_id:item.skus[0],
          price:item.compare_at_price_min_eur != null ? item.compare_at_price_min_eur:item.price_min_eur,
          item_brand:item.vendor,
          item_category:item.product_type,
           item_category2: item.collections[0]?.title,
          item_variant: "null",
                item_reviews: item.review_count,
      item_review_rating: item.review_ratings,

          in_stock: "yes",
          on_offer:item.compare_at_price_min_eur != null ? "yes" :"no" ,
          item_list_name:currentCollection,
          index: index,
          quantity: 1
          
        })
          
        } else {
           trackingProductsToSend.push({
          item_name:item.title,
          item_id:item.skus[0],
          price:item.compare_at_price_min != null ? item.compare_at_price_min:item.price_min,
          item_brand:item.vendor,
          item_category:item.product_type,
           item_category2: item.collections[0]?.title,
          item_variant: "null",
                item_reviews: item.review_count,
      item_review_rating: item.review_ratings,

          in_stock: "yes",
          on_offer:item.compare_at_price_min != null ? "yes" :"no" ,
          item_list_name:currentCollection,
          index: index,
          quantity: 1
          
        })
          
        }
       
      });
      window.dataLayer.push({ ecommerce: null });
window.dataLayer.push({
  event: 'view_item_list',
  ecommerce: {
    items:trackingProductsToSend 
  }
});
      $('body').on('click','[data-productid] .card__media', function(){
 
     console.log("selection clicked");
      let index =  $('[data-productid] .card__media').index(this);
      console.log(index);
     let ItemtoSend = trackingProductsToSend[index];
     console.log(ItemtoSend);
     window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'select_item',
            ecommerce: {
              items: [ItemtoSend]
            }
          });

   });
            $('body').on('click',"[data-productid] .card__heading", function(){

      console.log("selection clicked");
      let index =  $("[data-productid] .card__heading").index(this);  
      console.log(index);
     let ItemtoSend = trackingProductsToSend[index];
     console.log(ItemtoSend);
     window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'select_item',
            ecommerce: {
              items: [ItemtoSend]
            }
          });

   })
       $("[data-productid] .quickadd_boost").click(function(){
      let index = $("[data-productid] .quickadd_boost").index(this);
      console.log(index);
     let ItemtoSend = trackingProductsToSend[index];
     console.log(ItemtoSend);
         console.log("orignaldata");
         console.log( data.products[index]);
     window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              items: [ItemtoSend]
            }
          });
               console.log(trackingProductsToSend);


   })
      console.log(trackingProductsToSend);
    };
    
    /* Start boost 150398 */
    ProductPaginationInfinite.prototype._loadMoreProducts = function() {
        if (boostPFSConfig.general.collection_handle == 'new-products' && Globals.queryParams.page == 22) {
            return;
        }
        // Show Loading
        this.showLoading();
        // Prevent scrolling twice
        this.scrolling = true;
        // Next page
        this.nextPage++;
        // Send request if current page is smaller or equal to total number of pages
        var totalPage = Math.ceil(this.totalProduct / Globals.queryParams.limit);
        if (this.nextPage <= totalPage) {
            Globals.internalClick = true;
            // Set limit param
            FilterApi.setParam('limit', Globals.queryParams.limit);
            // Set new page param
            FilterApi.setParam('page', this.nextPage);
            if (Utils.FilterResult.isAdvancedPaginationType()) {
                // If the previous page feature is activated
                if (Utils.isLoadPreviousPagePaginationType()) {
                    // Save the previous page data
                    window.sessionStorage.setItem(this.settings.sessionStorageCurrentNextPage, this.nextPage);
                    window.sessionStorage.setItem(this.settings.sessionStoragePreviousPageEvent, 0);
                }
                // Apply filter with new navigation url
                FilterApi.applyFilter('page');
            } else {
                // Apply filter without new navigation url
                var filter = BoostPFS.instance.filter;
                FilterApi.getFilterData('page', filter.setData.bind(filter));
            }
        }
    }
    /* End boost 150398 */
    
    function formRequest(value) {
        return new Promise((resolve, reject) => {
            var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
            xhr.open("GET", value);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.onload = () => resolve(xhr.responseText);
            xhr.onerror = () => reject(xhr.statusText);
            xhr.send();
        });
    }
    ProductList.prototype.afterRender = function(data) {
        console.log('DATA', data)
        if (!data) {
            data = this.data;
        }
        console.log('DATA', data)
        // Ajax Price Boost 193162
        for (var item of data) {
            var valueRequest = Shopify.routes.root + 'products/' + item.handle + '?view=boost-pfs-multiple-currencies';
            var requestReg = formRequest(valueRequest);
            requestReg.then((res_success) => {
                var parse_res_success = JSON.parse(res_success);
                var itemEl = jQ('.product-card[my-data-id="' + parse_res_success.id + '"]');
                console.log('parse_res_success', parse_res_success);
                if (itemEl.length > 0) {
                    itemEl.find('.boost-pfs__item-price').html(buildPrice(parse_res_success));
                }
            }).catch((res_error) => {
                console.log(res_error)
            });
        }
        // END Ajax Price Boost 193162
    }
    
    
    /************************** END BUILD TOOLBAR **************************/
})();
